export default {"src":"/_next/static/media/pencil.af6e3ee6.svg","height":40,"width":40};